import React, { CSSProperties } from 'react';
import FadeLoader from "react-spinners/FadeLoader";
import { FormattedMessage } from 'react-intl';

const override: CSSProperties = {
	display: "block",
	margin: "0 auto",
	borderColor: "red"
};

function Spinner({show}) {
	return (
		<>
		  {show &&
		  	<div style={{position:"fixed", "zIndex":9999, left:"0px", top:"0px", width:"100%", height:"100%", backgroundColor:"black", opacity:"50%", verticalAlign:"middle"}}>
		  	  <div style={{marginLeft:"-100px"}}>
		  	    <FadeLoader
		  	      color={"#888888"}
		  	      loading={true}
		  	      cssOverride={override}
		  	      height={100}
		  	      width={25}
		  	      radius={5}
		  	      margin={100}
		  	      aria-label={<FormattedMessage id="loadingSpinner"/>}
		  	      data-testid="loader"
		  	    />
		  	  </div>
		  	</div>
		  }
		</>
	);
}

export default Spinner;